import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom-v6'
import { KeyRound, Languages, User } from 'lucide-react'
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@clouway/ui'

// Settings sections. Keys live in the `common` namespace (app is bg-primary).
const items = [
  { titleKey: 'nav.profile', url: '/', icon: User, isActive: (p: string) => p === '/' },
  { titleKey: 'nav.locale', url: '/locale', icon: Languages, isActive: (p: string) => p.startsWith('/locale') },
  { titleKey: 'nav.password', url: '/password', icon: KeyRound, isActive: (p: string) => p.startsWith('/password') },
] as const

function AppSidebar() {
  const { t } = useTranslation('common')
  const { pathname } = useLocation()

  return (
    <Sidebar>
      <SidebarHeader>
        <span className="px-2 py-1.5 text-sm font-semibold">{t('app.title')}</span>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              {items.map((item) => (
                <SidebarMenuItem key={item.url}>
                  <SidebarMenuButton asChild isActive={item.isActive(pathname)}>
                    <Link to={item.url}>
                      <item.icon />
                      <span>{t(item.titleKey)}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  )
}

export default AppSidebar
